import { sameUserId } from 'state/freeReactionEligibility'
import type { IBsvUpvalue } from 'types/answers'

export const hasActiveSeedPosition = (
    upvalues: IBsvUpvalue[] | null | undefined,
    currentUserId: string | number | null | undefined,
): boolean =>
    (upvalues || []).some(
        upvalue =>
            upvalue.is_seed === true &&
            upvalue.status !== 'failed' &&
            sameUserId(upvalue.from_user_id, currentUserId),
    )
